import { ElementRef, Injectable, Injector } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { DateTime } from 'luxon';
import { interval, Observable, Subject, Subscription } from 'rxjs';
import { TaskRowComponent } from '../shared/task-row/task-row.component';
import { SignalRHelper } from "shared/helpers/SignalRHelper";
import { SignalRService } from '@app/shared/services/signalr.service';
import { UserTaskDto } from '@shared/service-proxies/service-proxies';
import { UserProjectTaskDto } from '@shared/service-proxies/service-proxies';
import { TaskStateEnum } from '../models/taskState.enum';
import { ToastrType } from '@app/shared/common/models/toastrTypeEnum';
import { ToastrService } from 'ngx-toastr';
import { AppComponentBase } from '@shared/common/app-component-base';

@Injectable({
    providedIn: "root",
})

export class TimeTrackingService extends AppComponentBase {
    constructor(injector: Injector, private formBuilder: FormBuilder, private _signalRService: SignalRService, private toastrService: ToastrService) {
        super(injector);
        this.initSignalR();
    }

    // Click event locks to prevent start or stop timer from running twice
    // since the signalr event is emitted beofre api call to start or stop is complete
    // by the time the isCurrentlygoing on is set to tru when start button is clicked, the signalr event re-triggers the start timer
    // this property will lock that
    startEventLock: boolean = false;
    stopEventLock: boolean = false;

    // The timer subscription whenever anu task-row subscribes to the interval
    // Storing subscription in the service ensures that even though the component is destroyed, the observable keeps emitting values
    // Useful while filtering to keep the main timer running
    public timerSub: Subscription;

    // Subject to emit selected task filters
    selectedTaskFilterSubject: Subject<{ projectIds: number[]; taskIds: number[]; searchString: string; oldNew: boolean }> = new Subject<{
        projectIds: number[];
        taskIds: number[];
        searchString: string;
        oldNew: boolean
    }>();

    // Subject to emit currently ongoing task and a store for the same
    currentTaskSubject: Subject<TaskRowComponent> = new Subject<TaskRowComponent>();
    currentlyActiveTask: TaskRowComponent;
    outlookActiveTaskId: number = -1;
    outlookActiveProjectId: number = -1;
    // SignalR Subject
    signalRSubject: Subject<{ projectTaskId: number; isTimerStopped: boolean ;taskstateId:number}> = new Subject<{ projectTaskId: number; isTimerStopped: boolean ;taskstateId:number}>();
    taskHistoryRefresh = new Subject<void>();
    updateStatusOnTimeTrackingTab = new Subject<void>();

    // Subjects to reload inprogress and completed lists
    refreshTasks = new Subject<number>();
    goToTaskStateGroup = new Subject<number>();

    getStatusChnageObsFromTaskRow() {
        return this.updateStatusOnTimeTrackingTab.asObservable();
    }

    getActiveOutlookTaskId() {
        return this.outlookActiveTaskId;
    }
    getActiveOutlookProjectId() {
        return this.outlookActiveProjectId;
    }
    setOutlookActiveTask(taskId: number, ProjectID: number) {
        
        this.outlookActiveTaskId = taskId;
        this.outlookActiveProjectId = ProjectID;
    }
    // Observable to get the current task emitted
    getCurrentTaskObs() {
        return this.currentTaskSubject.asObservable();
    }
    //ProjecttaskArray:UserProjectTaskDto[] = [];
    //setProjectDetails(input){
    //    this.ProjecttaskArray=input;
    //}
    //getProjectDetails(taskState:number){
    //  let result =[];// new UserProjectTaskDto[]=[];
    //    this.ProjecttaskArray.forEach(t=>{
    //        let temp=new UserProjectTaskDto();
    //        var x=t;
    //        temp.userTaskList=[];
    //        x.userTaskList.forEach(tsk=>{
    //            if(tsk.taskStateId==taskState){
    //                temp.userTaskList.push(tsk);
    //            }
    //        });
    //        if(temp.userTaskList.length>0){
    //            if(taskState ==TaskStateEnum.New){
    //                temp.totalTime = x.newTotalTime;
    //            }              
    //            else if(taskState ==TaskStateEnum.Inprogress){
    //                temp.totalTime = x.progTotalTime;
    //            }
    //            else if(taskState ==TaskStateEnum.Overdue){
    //                temp.totalTime = x.overDueTotalTime;
    //            }
    //            else if(taskState ==TaskStateEnum.Completed){
    //                temp.totalTime = x.completedTotalTime;
    //            }
              
    //            temp.projectImage =x.projectImage;
    //            temp.projectName =x.projectName;
    //            temp.projectDescription =x.projectDescription;
    //            temp.projectId =x.projectId;
    //            result.push(temp);
    //        }

    //    })
    //    return result;
    //}
    // Emit the current ongoing task
    emitCurrentTask(currentTask: TaskRowComponent) {
        this.currentlyActiveTask = currentTask;
        this.currentTaskSubject.next(currentTask);
    }

    // Subject to transfer filters
    getSelectedTaskFilterObs() {
        return this.selectedTaskFilterSubject.asObservable();
    }

    // Emit the filters
    emitTaskFilters(filterObj: { projectIds: number[]; taskIds: number[]; searchString: string; oldNew: boolean }) {
        this.selectedTaskFilterSubject.next(filterObj);
    }
    getCurrentlyActiveTask1() {
        return this.currentlyActiveTask.task;
    }

    getCurrentlyActiveTask() {
        return this.currentlyActiveTask;
    }

    // set currently active task to undefined
    clearCurrentlyActiveTask() {
        this.currentlyActiveTask = undefined;
    }

    stopEventPropogation(event: Event) {
        event.stopPropagation();
    }

    clearOutlookActiveTask() {
        this.outlookActiveTaskId = -1;
        this.outlookActiveProjectId = -1;
    }

    // timer observable to subscribe to
    getTimerObservable(): Observable<number> {
        return interval(1000);
    }

    // Utility methods

    // build empty task reactive form
    buildEmptyTaskForm() {
        return this.formBuilder.group({
            projectId: [null, Validators.required],
            taskName: [null, [Validators.required, Validators.pattern(/\S/)]],
            assignedUserId: [null, Validators.required],
            taskStateId: [1, Validators.required],
            repoSteps: [null],
            systemInformation: [null],
            taskPriorityId: [2],
            taskSeverityId: [3],
            taskActivityId: [null, Validators.required],
            originalEstimatedHours: [null, [Validators.required]],
            remainingHours: [{ value: null, disabled: true }],
            completedHours: [null, [Validators.min(0)]],
            comments: [null],
            BillabilityStatus: [null, Validators.required],
            taskWorkTypeId:[null, Validators.required],
        });
    }

    // Set static values for fields
    setStaticDataForTaskForm(component: any) {
        component.taskStates = [
            { id: 1, name: this.l("New"), icon: "assets/common/images/timetracking/New (1).svg" },
            { id: 2, name: this.l("In progress"), icon: "assets/common/images/timetracking/Active (2).svg" },
            { id: 3, name: this.l("Overdue"), icon: "assets/common/images/timetracking/Removed (1).svg" },
            { id: 4, name: this.l("Completed"), icon: "assets/common/images/timetracking/Completed (1).svg" },
        ];
        component.priorities = [
            { id: 1, name: this.l("High") },
            { id: 2, name: this.l("Moderate") },
            { id: 3, name: this.l("Low") },
        ];
        component.severities = [
            { id: 1, name: this.l("Critical") },
            { id: 2, name: this.l("High") },
            { id: 3, name: this.l("Medium") },
            { id: 4, name: this.l("Low") },
        ];
        component.activities = [
            { id: 1, name: this.l("Development") },
            { id: 2, name: this.l("Design") },
            { id: 3, name: this.l("Requirement") },
            { id: 4, name: this.l("Documentation") },
            { id: 5, name: this.l("Testing")},
            { id: 6, name: this.l("Miscellaneous")},
        ];
        component.Billability = [
            { id: 1, name: "Billable" },
            { id: 2, name: "Non-Billable" },
        ];
        component.workItemTypes = 
        [{ id: 1, name: this.l('Bug'), icon: "assets/common/images/workitemtype/ico (1) (1).svg"},
         { id: 2, name: this.l('User Story'), icon: "assets/common/images/workitemtype/ico (7).svg" }, 
         { id: 3, name: this.l('Feature'), icon: "assets/common/images/workitemtype/ico (3).svg" }, 
         { id: 4, name: this.l('Task'), icon: "assets/common/images/workitemtype/ico (5) (1).svg" }, 
         { id: 5, name: this.l('Test Case'), icon: "assets/common/images/workitemtype/ico (6).svg" }, 
         { id: 6, name: this.l('Test Plan'), icon: "assets/common/images/workitemtype/Test_Plans_icon (2).svg" }, 
         { id: 7, name: this.l('Test Suite'), icon: "assets/common/images/workitemtype/Test_Suite_Icon.svg" },
         { id: 8, name: this.l('Epic'), icon: "assets/common/images/workitemtype/ico (2).svg" },
         { id: 9, name: this.l('Issue'), icon: "assets/common/images/workitemtype/ico (4).svg" },
         { id: 10, name: this.l('Ticket'), icon: "assets/common/images/workitemtype/Ticket_icon.svg" },
         {id: 11, name: this.l('Internal'), icon:"assets/common/images/workitemtype/ITP_Only_Logo (1).svg"},
      
        ];

    }

    setZeroTimeForLocalDate(date: Date): Date {
        let dateClone = new Date(date.getTime());
        dateClone.setHours(0, 0, 0, 0);
        return new Date(dateClone.getTime() - dateClone.getTimezoneOffset() * 60 * 1000);
    }

    // Find out total seconds from a timestamp
    calculateTotalSeconds(timeStamp: string): number {
        return timeStamp
            .split(":")
            .map((r) => parseInt(r))
            .map((r, i) => r * 60 ** (2 - i))
            .reduce((a, v) => (a += v), 0);
    }

    // Find out offset from a given starting time
    getOffsetFromStartingTime(startingTime: DateTime) {
        return Math.floor((new Date(DateTime.now().toUTC().toString()).getTime() - new Date(startingTime.toUTC().toString()).getTime()) / 1000);
    }

    // get local js date from a UTC datetime object
    getLocalJsDate(date: DateTime): Date {
        let jsDate = new Date(
            `${date.year}-${date.month < 10 ? "0" + date.month : date.month}-${date.day < 10 ? "0" + date.day : date.day}T${
                date.hour < 10 ? "0" + date.hour : date.hour
            }:${date.minute < 10 ? "0" + date.minute : date.minute}:${date.second < 10 ? "0" + date.second : date.second}`
        );
        return new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000);
    }

    // SignalR ***
    initSignalR() {
        abp.event.on("SignalRRefreshTimeTracking", (data) => {
            this.signalRCallBack.createcallBackFunctionsforSignalR(data)
        });
        // SignalRHelper.initSignalR(() => {
        //     this._signalRService.initSignalRConnection(this.signalRCallBack, "SignalRRefreshTimeTracking");
        // });
    }
   
    // Observable to get the current task emitted
    getSignalRSubjectObs() {
        return this.signalRSubject.asObservable();
    }

    // SignalR ***
    signalRCallBack = {
        createcallBackFunctionsforSignalR: (taskDetails: any) => {
            this.signalRSubject.next({ projectTaskId: taskDetails.projectTaskId, isTimerStopped: taskDetails.isTimerStopped,taskstateId:taskDetails.taskstateId });
        },
    };

    numberInputValidator(control: AbstractControl): { [key: string]: boolean } | null {
        if (!control.value || (control.value as string).includes("e") || (control.value as string).includes("-")) {
            return null;
        }
        return { numberInputValidator: true };
    }

    getTaskStateFromEnum(state: TaskStateEnum): string {
        if (state === TaskStateEnum.Inprogress) return "In Progress";
        return TaskStateEnum[state];
    }

    convertHoursToTimespan(hours: number): string {
        let hour = Math.floor(hours);
        let min = Math.floor((hours - hour) * 60);
        return `${hour < 10 && hour > 0 ? "0" + hour : hour}:${min < 10 && min > 0 ? "0" + min : min}:00`;
    }

    convertTimespanToHours(timespan: string): number {
        timespan = this.convertDecimalTimespanIntoNormalTimeSpan(timespan);
        let hours = parseInt(timespan.split(":")[0]);
        let min = parseInt(timespan.split(":")[1]);
        let sec = Math.floor(parseInt(timespan.split(":")[2]));
        let totalSeconds = hours * 3600 + min * 60 + sec;
        return parseFloat((totalSeconds / 3600).toFixed(50));
    }

    convertDecimalTimespanIntoNormalTimeSpan(timespan: string) {
        if (timespan.split(":")[0].includes(".")) {
            let min = parseInt(timespan.split(":")[1]);
            let sec = 0;
            let days = parseInt(timespan.split(":")[0].split(".")[0]);
            let newHours = parseInt(timespan.split(":")[0].split(".")[1]);
            let hours;
            if (days < 0) {
                hours = days * 24 - newHours;
            } else {
                hours = days * 24 + newHours;
            }
            return `${hours < 10 && hours >= 0 ? "0" + hours : hours}:${min < 10 ? "0" + min : min}:${sec < 10 ? "0" + sec : sec}`;
        } else {
            return timespan;
        }
    }

    minutesToTimestamp(minutes: number): string {
        let hours = Math.floor(minutes / 60);
        let min = minutes % 60;
        if (isNaN(hours) || isNaN(min)) return "--:--";
        return `${hours < 10 ? "0" + hours : hours}:${min < 10 ? "0" + min : min}`;
    }

    trimTimestamp(timestamp: string): string {
        if (!timestamp) return "00:00";
        return timestamp.split(":")[0] + ":" + timestamp.split(":")[1];
    }

    showTooltipForString(str: string, maxLength: number) {
        if (str && str.length <= maxLength) return true;
        return false;
    }

    showTopToastr(type: ToastrType, message: string, title?: string) {
        if (type === ToastrType.Info) this.toastrService.info(message, title);
        if (type === ToastrType.Success) this.toastrService.success(message, title);
        if (type === ToastrType.Warning) this.toastrService.warning(message, title);
        if (type === ToastrType.Error) this.toastrService.error(message, title);
    }
}
